<template>
  <main>
    <HeroPage :title="title" :description="description"></HeroPage>
    <Breadcrumb :list="breadcrumbList"></Breadcrumb>
    <section>
      <div class="section-container">
        <slot></slot>
      </div>
    </section>
  </main>
</template>

<script>
import Vue from "vue";

import HeroPage from "@/components/HeroPage.vue";
import Breadcrumb from "@/components/elements/Breadcrumb.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "Layout",
  components: {
    HeroPage,
    Breadcrumb,
  },
  data() {
    return {
      title: "Petição",
      description: "Impugnação",
      breadcrumbList: [],
    };
  },
  computed: {
    ...mapGetters("eleicaonet", ["getParamHotsite"]),
  },
  mounted() {
    this.breadcrumbList = this.$route.meta.breadcrumb;
    if (
      this.getParamHotsite.pages.petition &&
      this.getParamHotsite.pages.petition.layout
    ) {
      if (this.getParamHotsite.pages.petition.layout.title) {
        this.title = this.getParamHotsite.pages.petition.layout.title;
      }
      if (this.getParamHotsite.pages.petition.layout.description) {
        this.description =
          this.getParamHotsite.pages.petition.layout.description;
      }
    }
  },
});
</script>
